import { useSyncExternalStore } from 'react';

// Guest access lasts for this app session. A fresh launch starts at sign-in.
let guestMode = false;
const listeners = new Set<() => void>();

export function setGuestMode(value: boolean) {
  if (guestMode === value) return;
  guestMode = value;
  listeners.forEach(listener => listener());
}

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export function useGuestMode() {
  return useSyncExternalStore(subscribe, () => guestMode);
}
